<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-content-review`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.902 3.937l3.415 5.746 5.746 3.415a4 4 0 011.832 4.424L44.248 24l1.647 6.477a4 4 0 01-1.832 4.425l-5.746 3.415-3.415 5.745a4 4 0 01-4.425 1.833L24 44.248l-6.478 1.647a4 4 0 01-4.424-1.833l-3.415-5.745-5.746-3.415a4 4 0 01-1.832-4.425L3.752 24l-1.647-6.478a4 4 0 011.832-4.424l5.746-3.415 3.415-5.746a4 4 0 014.424-1.832L24 3.752l6.477-1.647a4 4 0 014.425 1.832zm-3.438 2.044L24.986 7.63a4 4 0 01-1.972 0L16.536 5.98l-3.415 5.746a4 4 0 01-1.394 1.394L5.98 16.536l1.648 6.478a4 4 0 010 1.972L5.98 31.463l5.746 3.416a4 4 0 011.394 1.394l3.415 5.746 6.478-1.648a4 4 0 011.972 0l6.478 1.648 3.415-5.746a4 4 0 011.394-1.394l5.746-3.415-1.648-6.478a4 4 0 010-1.972l1.648-6.478-5.746-3.415a3.999 3.999 0 01-1.394-1.394L31.464 5.98zm3.85 13.19l-2.829-2.828-11.313 11.314L15.515 22l-2.829 2.828 8.486 8.486 14.142-14.142z"/></svg>
</template>
<script>

export default {
  name: 'IconContentReview',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
